import React, { Component } from 'react';
import { connect } from 'react-redux';
import { difference, union } from 'lodash';
import { Text } from '../../components/Text';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { LoadingBar } from '../../components/util/LoadingBar';
import { MultipleChoiceControl } from '../../components/controls/MultipleChoiceControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const optionsYoung = [
  'get_finances_on_track',
  'become_debt_free',
  'managing_investments',
  'protect_your_family',
  'save_up_for_goal',
  'prepare_for_retirement',
];

const optionsOld = [
  'prepare_for_retirement',
  'managing_investments',
  'save_up_for_goal',
  'become_debt_free',
  'legacy_plan',
  'medical_expenses',
  'longevity_planning',
];

const optionsData = {
  get_finances_on_track: {
    label: 'Getting finances on track',
    description: 'Get your budget, savings, and investments working together',
    image: require('images/FinancesOnTrack.png'),
  },
  become_debt_free: {
    label: 'Becoming debt-free',
    description: 'Pay off your loans sooner without sacrificing your other goals',
    image: require('images/DebtFree.png'),
  },
  managing_investments: {
    label: 'Managing investments',
    description: 'Build a complete portfolio and minimize your risk',
    image: require('images/ManagingInvestment.png'),
  },
  protect_your_family: {
    label: 'Protecting your family',
    description: "Make sure you're financially insured against unforeseen events",
    image: require('images/Family.png'),
  },
  save_up_for_goal: {
    label: 'Saving up for a goal',
    description: 'Get on track for a new home, college fund, travel, and more',
    image: require('images/BuyingHome.png'),
  },
  prepare_for_retirement: {
    label: 'Preparing for retirement',
    description: "Decide how much to save, and when you'll be able to retire",
    image: require('images/Retirement.png'),
  },
  legacy_plan: {
    label: 'Legacy planning',
    description: 'Ensure your surviving spouse and heirs are taken care of',
    image: require('images/Inheritance.png'),
  },
  medical_expenses: {
    label: 'Medical expenses',
    description: 'Have the insurance and savings you need to protect your health',
    image: require('images/MedicalExpense.png'),
  },
  longevity_planning: {
    label: 'Longevity planning',
    description: 'Get prepared for living into your nineties, and beyond',
    image: require('images/LongevityPlanning.jpg'),
  },
};

class Priorities extends Component {
  constructor(props) {
    super(props);
    this.state = { priorities: props.qna_hash.priorities ? props.qna_hash.priorities.answer : [] };
  }

  componentDidMount() {
    this.props.pathAware('priorities');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.priorities) {
      this.setState({
        priorities: props.qna_hash.priorities.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        priorities: {
          question: "What's your biggest financial focus today?",
          answer: this.state.priorities,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (value, isSelected) => {
    const method = isSelected ? union : difference;
    this.setState({ priorities: method(this.state.priorities, [value]) });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { priorities } = this.state;

    if (!qna_hash.primaryAge) {
      return <LoadingBar />;
    }
    let oldest = parseInt(qna_hash.primaryAge.answer);
    if (qna_hash.hasPartner.answer) {
      const partner = parseInt(qna_hash.partnerAge.answer);
      oldest = oldest > partner ? oldest : partner;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What's your biggest financial focus today?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text use="body1" className="ml-4 mr-4">
            Select up to 2 options from the list below&mdash;Focus on your highest priorities for now.
          </Text>
        </div>

        <div style={{ width: '100%' }}>
          <MultipleChoiceControl
            values={priorities}
            onChange={this.onChange}
            field_type="multi_choice"
            max_selections={2}
            options={oldest < 50 ? optionsYoung : optionsOld}
            option_data={optionsData}
          />
        </div>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(Priorities);
